import { render } from "./B2bNewUserExistPermissions.vue?vue&type=template&id=7307966e&scoped=true&lang=pug"
import script from "./B2bNewUserExistPermissions.vue?vue&type=script&lang=js"
export * from "./B2bNewUserExistPermissions.vue?vue&type=script&lang=js"

import "./B2bNewUserExistPermissions.vue?vue&type=style&index=0&id=7307966e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7307966e"]])

export default __exports__